var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('distortion'),_c('today-image-list',{ref:"todayImageList"}),_c('adsense',{attrs:{"ad-client":"ca-pub-8312298907467075","ad-slot":"1817723757"}}),(_vm.isLogin)?_c('div',[_c('uploader',{on:{"end-upload":_vm.updateUser}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }